/** @format */
import styled from 'styled-components';

import { theme } from '@toucan/config/theme';

import { ProductComparisonItemHeader } from '../../product-comparison-item.styles';

export const ProductComparisonItemInStockHeader = styled(
    ProductComparisonItemHeader
)`
    grid-template-columns: min-content 1fr;

    .product-comparison-item-image {
        width: 7.2rem;
        height: 7.2rem;
        box-shadow: var(--effects-shadow-base);
        border-radius: 0.4rem;
    }

    .product-comparison-item-details {
        display: flex;
        flex-direction: column;
    }

    .product-comparison-item-pill {
        width: fit-content;
        color: var(--colors-text-secondary);
        background-color: var(--colors-surface-accent);
        ${theme.typography.caption_highlight};
        padding: 0px var(--layout-spacing-4);
    }

    .product-comparison-item-price {
        ${theme.typography.body_large_highlight};
        color: var(--colors-text-secondary);
    }

    .product-comparison-item-condition {
        font-size: 1.2rem;
    }

    .product-comparison-item-button {
        grid-column: 1 / span 2;
        justify-self: center;
        min-width: 14rem;
    }
`;
